/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CapsulePartyDto } from '../models/capsule-party-dto';
import { CapsulePartyEntry } from '../models/capsule-party-entry';
import { getManyBaseMgmtCustomerControllerMember } from '../fn/customer/get-many-base-mgmt-customer-controller-member';
import { GetManyBaseMgmtCustomerControllerMember$Params } from '../fn/customer/get-many-base-mgmt-customer-controller-member';
import { GetManyMemberResponseDto } from '../models/get-many-member-response-dto';
import { getOneBaseMgmtCustomerControllerMember } from '../fn/customer/get-one-base-mgmt-customer-controller-member';
import { GetOneBaseMgmtCustomerControllerMember$Params } from '../fn/customer/get-one-base-mgmt-customer-controller-member';
import { Member } from '../models/member';
import { mgmtCustomerControllerCapsuleEntries } from '../fn/customer/mgmt-customer-controller-capsule-entries';
import { MgmtCustomerControllerCapsuleEntries$Params } from '../fn/customer/mgmt-customer-controller-capsule-entries';
import { mgmtCustomerControllerCapsuleSearch } from '../fn/customer/mgmt-customer-controller-capsule-search';
import { MgmtCustomerControllerCapsuleSearch$Params } from '../fn/customer/mgmt-customer-controller-capsule-search';
import { mgmtCustomerControllerCapsuleShow } from '../fn/customer/mgmt-customer-controller-capsule-show';
import { MgmtCustomerControllerCapsuleShow$Params } from '../fn/customer/mgmt-customer-controller-capsule-show';

@Injectable({ providedIn: 'root' })
export class CustomerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseMgmtCustomerControllerMember()` */
  static readonly GetManyBaseMgmtCustomerControllerMemberPath = '/api/mgmt-customers';

  /**
   * Retrieve multiple Members.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtCustomerControllerMember()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtCustomerControllerMember$Response(params?: GetManyBaseMgmtCustomerControllerMember$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyMemberResponseDto>> {
    const obs = getManyBaseMgmtCustomerControllerMember(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Members.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtCustomerControllerMember$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtCustomerControllerMember(params?: GetManyBaseMgmtCustomerControllerMember$Params, context?: HttpContext): Observable<GetManyMemberResponseDto> {
    const resp = this.getManyBaseMgmtCustomerControllerMember$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyMemberResponseDto>): GetManyMemberResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtCustomerControllerMember()` */
  static readonly GetOneBaseMgmtCustomerControllerMemberPath = '/api/mgmt-customers/{id}';

  /**
   * Retrieve a single Member.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtCustomerControllerMember()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtCustomerControllerMember$Response(params: GetOneBaseMgmtCustomerControllerMember$Params, context?: HttpContext): Observable<StrictHttpResponse<Member>> {
    const obs = getOneBaseMgmtCustomerControllerMember(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Member.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtCustomerControllerMember$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtCustomerControllerMember(params: GetOneBaseMgmtCustomerControllerMember$Params, context?: HttpContext): Observable<Member> {
    const resp = this.getOneBaseMgmtCustomerControllerMember$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Member>): Member => r.body)
    );
  }

  /** Path part for operation `mgmtCustomerControllerCapsuleSearch()` */
  static readonly MgmtCustomerControllerCapsuleSearchPath = '/api/mgmt-customers/capsule/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtCustomerControllerCapsuleSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtCustomerControllerCapsuleSearch$Response(params: MgmtCustomerControllerCapsuleSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CapsulePartyDto>>> {
    const obs = mgmtCustomerControllerCapsuleSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtCustomerControllerCapsuleSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtCustomerControllerCapsuleSearch(params: MgmtCustomerControllerCapsuleSearch$Params, context?: HttpContext): Observable<Array<CapsulePartyDto>> {
    const resp = this.mgmtCustomerControllerCapsuleSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<CapsulePartyDto>>): Array<CapsulePartyDto> => r.body)
    );
  }

  /** Path part for operation `mgmtCustomerControllerCapsuleShow()` */
  static readonly MgmtCustomerControllerCapsuleShowPath = '/api/mgmt-customers/capsule/show';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtCustomerControllerCapsuleShow()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtCustomerControllerCapsuleShow$Response(params: MgmtCustomerControllerCapsuleShow$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CapsulePartyDto>>> {
    const obs = mgmtCustomerControllerCapsuleShow(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtCustomerControllerCapsuleShow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtCustomerControllerCapsuleShow(params: MgmtCustomerControllerCapsuleShow$Params, context?: HttpContext): Observable<Array<CapsulePartyDto>> {
    const resp = this.mgmtCustomerControllerCapsuleShow$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<CapsulePartyDto>>): Array<CapsulePartyDto> => r.body)
    );
  }

  /** Path part for operation `mgmtCustomerControllerCapsuleEntries()` */
  static readonly MgmtCustomerControllerCapsuleEntriesPath = '/api/mgmt-customers/capsule/{partyId}/entries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtCustomerControllerCapsuleEntries()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtCustomerControllerCapsuleEntries$Response(params: MgmtCustomerControllerCapsuleEntries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CapsulePartyEntry>>> {
    const obs = mgmtCustomerControllerCapsuleEntries(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtCustomerControllerCapsuleEntries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtCustomerControllerCapsuleEntries(params: MgmtCustomerControllerCapsuleEntries$Params, context?: HttpContext): Observable<Array<CapsulePartyEntry>> {
    const resp = this.mgmtCustomerControllerCapsuleEntries$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<CapsulePartyEntry>>): Array<CapsulePartyEntry> => r.body)
    );
  }

}
